import styled, { css } from "styled-components"

import { minWidth } from "utils"

import { citationStyles } from "../citations/styles"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const Title = styled.div`
  margin-bottom: 1.5rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;

  ${({ priority }) =>
    priority === 1
      ? css`
          font-size: 2.3rem;
          line-height: 1.3;

          ${minWidth.tablet`
            font-size: 2.6rem;
          `}

          ${minWidth.hamburgerLarge`
            font-size: 3rem;
          `}
        `
      : priority === 2
      ? css`
          font-size: 1.6rem;
          line-height: 1.62;

          ${minWidth.hamburgerLarge`
            font-size: 3rem;
            line-height: 1.3;
          `}
        `
      : css`
          font-size: 1.8rem;
          font-style: italic;
          line-height: 1.5;
        `}
`

export const UnorderedList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`

export const UnorderedListItem = styled.li`
  margin-bottom: 1rem;
  padding-left: 3rem;
  font-size: 1.6rem;
  line-height: 1.62;
  background-image: radial-gradient(circle, #b5471f, #b5471f 2px, white 3px, white);
  background-position: 0px 0.7rem;
  background-size: 1rem 1rem;
  background-repeat: no-repeat;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${minWidth.hamburgerLarge`
    font-size: 1.8rem;
    line-height: 1.56;
    background-position: 0px 0.9rem;
  `}

  a {
    text-decoration: underline;
    color: #b5471f;
  }

  ${citationStyles}
`

export const OrderedList = styled.ol`
  margin: 0;
  padding: 0;
  list-style-type: none;
  counter-reset: customlistcounter;
`

export const OrderedListItem = styled.li`
  position: relative;
  margin-bottom: 2rem;
  padding-left: 7.2rem;
  font-size: 1.6rem;
  line-height: 1.62;
  counter-increment: customlistcounter;

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 2.5rem;
    height: 2.5rem;
    border: 2px solid #f1f1f1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 1.5rem;
    font-weight: 500;
    background-color: #b5471f;
    color: white;
    content: counter(customlistcounter) " ";
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  ${minWidth.hamburgerLarge`
    font-size: 1.8rem;
    line-height: 1.56;
  `}

  a {
    text-decoration: underline;
    color: #b5471f;
  }

  ${citationStyles}
`
